import IconDotted from "@/assets/svgs/icon-dotted.svg";
import { ReactComponent as IconEllipse } from "@/assets/svgs/icon-ellipse.svg";
import Button from '@/components/Button/index';
import { checkType } from "@/utils/check-type-etr-status";
import usePage from "@/hooks/use-page";
import { useLocation, useNavigate } from "@/lib/router-dom/index";
import { uniqueId } from 'lodash';
import moment from 'moment';
import Breadcrumbs from "@/componentsDS/Breadcrumbs/index";
import { useEffect } from "react";
import useEtrDocument from "@/hooks/use-etr-document/index";
import { feature, features } from '@/utils/feature-verifier';
import ReactDOM from "react-dom";
import { featureConstant } from "@/constants/configuration/feature";

export function EndorsementChainTableView(id, endorsementChain, index, checkType, item) {
	return <div className="endorsement_chain__container__table__row" key={id}>
		<div className="endorsement_chain__container__table__col endorsement_chain__ellipse">
			<IconEllipse />
			{(endorsementChain?.length - 1 !== index) && <div className="endorsement_chain__container__table__col__line" style={{ backgroundImage: `url(${IconDotted})` }}></div>}
		</div>
		<div className="endorsement_chain__container__table__col">
			<div className='endorsemtn_chain__content'>
				<div className='endorsement_chain__text__title'>{checkType(item?.type)}</div>
				<span className='endorsement_chain__text__sub'>
					{/** time stamp is presented in epoch format, hence manually converting to local timezone */}
					{moment(item.timestamp).local().format('DD MMM YYYY, hh:mm a')}
				</span>
			</div>
		</div>
		<div className="endorsement_chain__container__table__col">
			<div className='endorsemtn_chain__content'>
				<span className='endorsement_chain__text__sub'>{item?.owner}</span>
			</div>
		</div>
		<div className="endorsement_chain__container__table__col">
			<div className='endorsemtn_chain__content'>
				<span className='endorsement_chain__text__sub'>{item?.holder}</span>
			</div>
		</div>
	</div>;
}

const EndorsementChainPage = () => {

	const { goTo } = useNavigate();
	const { currentState } = useLocation();

	useEffect(() => {
		if (!currentState) {
			goTo(-1);
		}
	}, [currentState]);

	const { endorsementChain, etrDocDetails, transferableRecordId } = currentState;
	const isETRIGPNITRV5FeatureEnabled = feature(featureConstant?.ETR_IGPNI_TR_V5);

	const pageTitle = "Endorsement Chain";
	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label: '',
				link: '/'
			},
			{
				label: `E-Transferable Record`,
				link: '/record-transfer'
			},
			{
				label: etrDocDetails?.name,
				link: `/record-transfer/record-details/${etrDocDetails?.transferableRecordId}`
			},
			{
				label: 'Endorsement Chain',
				link: ''
			}
		]
	});

	const {
		fetchEtrDocumentEndorsechainDetails,
		etrDocEndorsechainDetails,
		etrDocEndorsechainDetailsLoading
	} = useEtrDocument();

	useEffect(() => {
		if (isETRIGPNITRV5FeatureEnabled || feature(features.TT_HOTFIX)) {
			fetchEtrDocumentEndorsechainDetails(transferableRecordId);
		}
	}, []);

	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />
			<div className="title-header">
				<div className="title-header__left">
					<div
						className="title-header__title"
						data-testid={"title-header"}
					>
						{pageTitle}
					</div>
				</div>
			</div>
			<div className="endorsement_chain__container">
				<div className='endorsement_chain__container__table'>
					{!isETRIGPNITRV5FeatureEnabled && <div className="endorsement_chain__container__table__row">
						<div className="endorsement_chain__container__table__col"></div>
						<div className="endorsement_chain__container__table__col"></div>
						<div className="endorsement_chain__container__table__col">
							<div className='endorsemtn_chain__content'>
								<div className="endorsement_chain__text__header">
									Owner
								</div>
							</div>
						</div>
						<div className="endorsement_chain__container__table__col">
							<div className='endorsemtn_chain__content'>
								<div className="endorsement_chain__text__header">
									Holder
								</div>
							</div>
						</div>
					</div>}
					{(endorsementChain && endorsementChain.length > 0) && endorsementChain.map((item, index) => {
						const id = uniqueId()
						return (
							EndorsementChainTableView(id, endorsementChain, index, checkType, item)
						)
					})}
					{(feature(features.TT_HOTFIX) || isETRIGPNITRV5FeatureEnabled) && (etrDocEndorsechainDetails && etrDocEndorsechainDetails?.endorsementChain?.length > 0) && etrDocEndorsechainDetails?.endorsementChain?.map((item, index) => {
						const id = uniqueId()
						return (
							!isETRIGPNITRV5FeatureEnabled ? EndorsementChainTableView(id, etrDocEndorsechainDetails?.endorsementChain, index, checkType, item) : <div className="endorsement_chain__container__table__row__remarks" key={id}>
								<div className="endorsement_chain__container__table__col__remarks">
									<div className="endorsement_chain__ellipse">
										<IconEllipse />
										{!(endorsementChain?.length - 1 === index) && (
											<div className="endorsement_chain__container__table__col__line__remarks"
												style={{ backgroundImage: `url(${IconDotted})` }}
											></div>
										)}
										<span className='endorsemtn_chain__content__remarks'>
											<span className='endorsement_chain__text__title__remarks'>{checkType(item.type)}</span>
										</span>
									</div>
									<div className="">
										<div className='endorsemtn_chain__content'>
											<span className='endorsement_chain__text__sub'>
												{/** time stamp is presented in epoch format, hence manually converting to local timezone */}
												{moment(item.timestamp).local().format('DD/MM/YYYY, hh:mm A')}
											</span>
										</div>
									</div>
								</div>
								<div className="endorsement_chain__container__table__col__remarks__address">
									<div>
										<div className='endorsemtn_chain__content'>
											<span className='endorsement_chain__text__sub'>Owner</span>
										</div>
										<div className='endorsemtn_chain__content'>
											<span className='endorsement_chain__text__sub__remarks'>{item?.owner}</span>
										</div>
									</div>
									<div>
										<div className='endorsemtn_chain__content'>
											<span className='endorsement_chain__text__sub'>Holder</span>
										</div>
										<div className='endorsemtn_chain__content'>
											<span className='endorsement_chain__text__sub__remarks'>{item?.holder}</span>
										</div>
									</div>
									<div>
										<div className='endorsemtn_chain__content'>
											<span className='endorsement_chain__text__sub'>Remarks</span>
										</div>
										<div className='endorsemtn_chain__content'>
											<span className='endorsement_chain__text__sub__remarks'>{item?.remark || '-'}</span>
										</div>
									</div>
								</div>
							</div>
						)
					})}
				</div>
			</div>
			<div className="DS__layout__footer">
				<div className="layout-default__sticky-actions">
					<div className="layout-default__sticky-actions__left">
						<Button text="Back"
							sizing='Medium'
							full noborder maxWidth='154'
							submit={() => {
								goTo(`/record-transfer/record-details/${transferableRecordId}`)
							}}
						/>
					</div>
				</div>
			</div>
			{(etrDocEndorsechainDetailsLoading) && ReactDOM.createPortal(
				<div className="modal white">
					<div className="loading">
						<img src="/loading.gif" />
					</div>
				</div>,
				document.body
			)}
		</>
	);
}

export default EndorsementChainPage
